/** Text to show when an API response is not ok. Prefers field errors, then the server message. */
export function messageFromApiError(body, status) {
    const details = (body?.details ?? [])
        .map((detail) => detail.message?.trim())
        .filter((message) => Boolean(message));
    if (details.length > 0)
        return details.join(' ');
    const message = body?.message?.trim();
    if (message)
        return message;
    if (status === 401)
        return 'Your session has expired. Please sign in again.';
    if (status === 403)
        return 'You do not have permission to do that.';
    if (status === 404)
        return 'We could not find what you asked for.';
    if (status === 409) {
        return 'That conflicts with something already saved. Please refresh and try again.';
    }
    if (status === 429)
        return 'Too many attempts. Please wait a moment and try again.';
    return 'Something went wrong. Please try again.';
}
//# sourceMappingURL=apiError.js.map